var emailValid = false;
var vatValid = false;
var passwordValid = false;

$('#RegisterForm-vat').on('input propertychange', function (e) {
    var valueChanged = false;
    if (e.type=='propertychange') {
        valueChanged = e.originalEvent.propertyName=='value';
    } else {
        valueChanged = true;
    }
    if (valueChanged) {
      var newVATNumber = checkVATNumber ($('#RegisterForm-vat').val());
      if (newVATNumber) {
        $('#RegisterForm-vat').removeClass('input--error');
        $('#RegisterForm-vat-error').hide();
        vatValid = true;
      } else {
        $('#RegisterForm-vat').addClass('input--error');
        $('#RegisterForm-vat-error').show();
        vatValid = false;
      }
      $('#RegisterForm-submit').prop("disabled", !(emailValid && vatValid && passwordValid));
    }
});

$('#RegisterForm-email').on('input propertychange', function (e) {
    var valueChanged = false;
    if (e.type=='propertychange') {
        valueChanged = e.originalEvent.propertyName=='value';
    } else {
        valueChanged = true;
    }
    if (valueChanged) {
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      var isEmailValid = regex.test($('#RegisterForm-email').val());
      if (isEmailValid) {
        $('#RegisterForm-email').removeClass('input--error');
        $('#RegisterForm-email-error').hide();
        emailValid = true;
        
      } else {
        $('#RegisterForm-email').addClass('input--error');
        $('#RegisterForm-email-error').show();
        emailValid = false;
      }
      $('#RegisterForm-submit').prop("disabled", !(emailValid && vatValid && passwordValid));
    }
});

$('#RegisterForm-password').on('input propertychange', function (e) {
    var valueChanged = false;
    if (e.type=='propertychange') {
        valueChanged = e.originalEvent.propertyName=='value';
    } else {
        valueChanged = true;
    }
    if (valueChanged) {
      var password = $('#RegisterForm-password').val();
      if (password && password.length > 5) {
        $('#RegisterForm-password').removeClass('input--error');
        $('#RegisterForm-password-error').hide();
        passwordValid = true;
        
      } else {
        $('#RegisterForm-password').addClass('input--error');
        $('#RegisterForm-password-error').show();
        passwordValid = false;
      }
      $('#RegisterForm-submit').prop("disabled", !(emailValid && vatValid && passwordValid));
    }
});